import { styled } from 'styled-components';
import { Button } from 'antd';
import { NavLink as RouterNavLink } from 'react-router-dom';

export const SiteName = styled.div`
  font-size: 18px;
`;

export const NavigationMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const NavLink = styled(RouterNavLink)`
  text-decoration: none;
  color: inherit;
  display: inline-flex;
  align-items: center;

  /* react-router の NavLink が現在ルート一致時に付与する .active を起点にハイライトする。
     hover も明示しないと AntD text Button の hover 色に上書きされる。
     色は AntD の colorPrimary に追従させる（ConfigProvider の cssVar 有効化が前提）。 */
  &.active .ant-btn,
  &.active .ant-btn:hover {
    color: var(--ant-color-primary);
    font-weight: 600;
  }
`;

export const LogoutButton = styled(Button)`
  color: #ff4d4f;

  &:hover {
    color: #ff7875;
    background-color: #fff2f0;
  }
`;

export const HeaderBlock = styled.header`
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 64px;
  background: #fff;
  border-bottom: 1px solid #d9d9d9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;
